import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaEdit, FaEnvelope, FaEnvelopeOpen, FaMagic, FaPlane, FaPlaneDeparture, FaSms, FaSpinner, FaTelegramPlane, FaTimes, FaTrashAlt } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Form, Modal, Button } from 'react-bootstrap';
import SummernoteEditorNewsLetters from './summernoteNewsLetters';
import { getAuthToken } from '../../../authToken';

const NewsLetters = ({ titre }) => {
    useAuth();
    const URL_DE_LA_VERSION_WEB = process.env.REACT_APP_ETRAINAPP + '/certif_pmp.html';
    const URL_DE_LA_VERSION_WEB1 = process.env.REACT_APP_ETRAINAPP + '/certif_pmp_2026.html';
    const user_id = localStorage.getItem('user_id');
    const [activeMenu, setActiveMenu] = useState('sms');
    const [selectedNewsletter, setSelectedNewsletter] = useState(null);
    const [contenuNewsletter, setContenuNewsletter] = useState('');
    const [showTemplates, setShowTemplates] = useState(false);
    const [hoveredTemplate, setHoveredTemplate] = useState(null);
    const [currentInput, setCurrentInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });

    // Nouveaux états pour les champs De, À, Objet
    const [expediteur, setExpediteur] = useState('INOVACT Training');
    const [destinataire, setDestinataire] = useState([]);
    const [objet, setObjet] = useState('');
    const [utilisateurs, setUtilisateurs] = useState([]);
    const [utilisateursSms, setUtilisateursSms] = useState([]);

    const animatedComponents = makeAnimated();


    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | NewsLetters"; // Définit le titre de la page
        }
    }, [user_id]);


    const [typeDestinataire, setTypeDestinataire] = useState('utilisateur');
    const [groupes, setGroupes] = useState([]);
    const [groupesDestinataire, setGroupesDestinataire] = useState([]);

    const fetchGroupes = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-groupe-globale/');
            if (response.ok) {
                const data = await response.json();
                setGroupes(data.map(groupe => ({
                    value: groupe.id,
                    label: groupe.nom
                })));
            } else {
                console.error('Erreur lors de la récupération des groupes');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    // Fetch des utilisateurs
    const fetchUtilisateurs = async () => {
        try {

            const token = localStorage.getItem('access_token');

            // Envoi au backend
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-utilisateurs/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            const data = await response.json();
            setUtilisateurs(data.map(user => ({
                value: user.email,
                label: `${user.email}`
            })));
            setUtilisateursSms(data.map(user => ({
                value: user.tel, // Priorité: tel > telephone > phone
                label: `${user.tel} - ${user.email || ''}`
            })).filter(user => user.value)); // Filtrer les utilisateurs sans numéro
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const [newsletters, setNewsletters] = useState([]);
    const [newslettersLoading, setNewslettersLoading] = useState(false);
    // Fetch des newsletters depuis l'API
    const fetchNewsletters = async () => {
        try {
            setNewslettersLoading(true)
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-newsletters/');
            if (response.ok) {
                const data = await response.json();
                setNewsletters(data);
            } else {
                console.error('Erreur lors de la récupération des newsletters');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setNewslettersLoading(false)
        }
    };

    useEffect(() => {
        fetchUtilisateurs();
        fetchNewsletters();
        fetchGroupes();
    }, []);

    // Templates HTML avec styles intégrés
    const templates = [
        {
            id: 1,
            nom: "Standard",
            description: "Template professionnel avec tableaux et structure formelle",
            html: `
                
                <div style="font-family: Arial, sans-serif; max-width: 650px; margin: 0 auto; background: #d9dce159;">
                    <!-- En-tête avec image -->
                    <div style="text-align: center;">
                        <img src="https://api-etrainapp.ivtapp.com/static/acces_app/Banni%C3%A8re.png" alt="INOVACT Training" style="width: 100%; max-width: 650px; height: auto; display: block;">
                    </div>

                    <!-- Contenu principal -->
                    <div style="line-height: 1.6; color: #333; padding-left: 30px; padding-right: 30px; padding-top: 10px; padding-bottom: 10px;">
                        <p style="margin-bottom: 10px; margin-top: 15px; ">Cher(e) {utilisateur},</p>

                        <p style="margin-bottom: 10px; text-align: justify;">
                            Vous avez acquis de l'expérience à travers différents projets. Aujourd'hui, vous pouvez valider vos compétences à l'international grâce à la <strong>certification PMP® (Project Management Professional)</strong> conçu par des chefs de projet pour des chefs de projet.
                        </p>

                        <p style="margin-bottom: 10px; text-align: justify;">
                            Rejoignez dès <a href="https://inovact.com/preparation-au-pmp/">maintenant</a> nos sessions de préparation à l'examen conçues pour transformer votre pratique de la gestion de projet et vous préparer à <strong>Décrocher le PMP</strong> au premier essai.
                        </p>

                        <!-- Bloc Réseaux sociaux -->
                        <div style="margin: 20px 0; background: #f8f9fa; padding: 15px; border-radius: 8px; border-left: 4px solid #2c5aa0;">
    <div style="display: flex; align-items: center; justify-content: space-between; gap: 15px;">
        <p style="font-size: 11px; color: #666; margin: 0; flex: 1;">
            Restez informé de nos actualités, conseils et événements en nous suivant sur nos différents réseaux sociaux
        </p>
        <div style="display: flex; gap: 8px; flex-shrink: 0;">
            <a href="https://www.facebook.com/inovact/" style="border-radius: 6px; display: flex; align-items: center; justify-content: center; padding-left: 10px">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/2023_Facebook_icon.svg/640px-2023_Facebook_icon.svg.png" alt="Facebook" style="border: 0;" width="25" height="25">
            </a>
            
                                            <a href="https://x.com/Inovact_Sarl" style="border-radius: 6px; display: flex; align-items: center; justify-content: center; padding-left: 10px">
                                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/X_%28formerly_Twitter%29_logo_late_2025.svg/640px-X_%28formerly_Twitter%29_logo_late_2025.svg.png" alt="Twitter" style="border: 0;" width="25" height="25">
                                            </a>
            <a href="https://www.linkedin.com/company/inovact" style="border-radius: 6px; display: flex; align-items: center; justify-content: center; padding-left: 10px">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/LinkedIn_PNG16.png/640px-LinkedIn_PNG16.png" alt="LinkedIn" style="border: 0;" width="25" height="25">
            </a>
        </div>
    </div>
</div>

                        <!-- Bloc Code Promo Design Moderne -->
<div style="margin: 20px 0; text-align: center; background: #2c5aa0; padding: 12px; border-radius: 6px; color: white;">
    <div style="font-size: 14px; font-weight: bold; line-height: 1.3;">
        🔥 Avec le Code promo <strong>HNY2026</strong> 
        - <strong>Profitez Jusqu'à 70% de réduction</strong>
    </div>
</div>

                        <!-- Section Pourquoi se faire certifier -->
                        <div style="margin: 20px 0;">
                            <h3 style="color: #2c5aa0; margin-bottom: 10px;">Pourquoi se faire certifier ?</h3>
                            <ul style="color: #333; line-height: 1.6; padding-left: 05px; margin-left: 05px;">
                                <li style="margin-bottom: 5px; list-style-position: inside;">
                                    Une reconnaissance mondiale
                                </li>
                                <li style="margin-bottom: 5px; list-style-position: inside;">
                                    Une opportunité unique de rejoindre une communauté mondiale de chefs de projets certifiés
                                </li>
                                <li style="margin-bottom: 5px; list-style-position: inside;">
                                    Un accès à des opportunités internationales
                                </li>
                                <li style="margin-bottom: 5px; list-style-position: inside;">
                                    Un gain de crédibilité auprès des recruteurs et partenaires
                                </li>
                                <li style="margin-bottom: 5px; list-style-position: inside;">
                                    Une meilleure façon de gérer les projets
                                </li>
                            </ul>
                        </div>

                    <!-- Section Prochaine affiche -->
                    <div style="text-align: center; margin: 20px 0;">
                        <img src="https://api-etrainapp.ivtapp.com/static/acces_app/nouvelle_affiche_pmp.png" alt="Mettre Prochaine affiche PMP" style="max-width: 100%; height: auto; border-radius: 8px;">
                    </div>

                    <!-- Tableau des prochaines dates PMP - VERSION COMPACTE -->

                    <div style="margin: 20px 0;">
                        <h3 style="color: #2c5aa0; margin-bottom: 15px; font-size: 16px;">Nos prochaines dates pour le PMP®</h3>
                        
                        <div style="background: #ffffff; border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden;">
                            
                            <!-- Ligne Cotonou -->
                            <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                    <strong>Préparation à la certification Project Management Professional PMP®</strong> à <strong>Cotonou</strong> les 17,18,24,25,31 Jan 2026
                                    <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                        Formation - coaching - simulateur - frais d'exam • Code: IVTPMP • 1 610 000 FCFA
                                    </div>
                                </div>
                                <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                    <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                </div>
                            </div>

                            <!-- Ligne Lomé -->
                            <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                    <strong>Préparation à la certification Project Management Professional PMP®</strong> à <strong>Lomé</strong> les 14,15,21,22,28 Mar 2026
                                    <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                        Formation - coaching - simulateur - frais d'exam • Code: IVTPMP • 1 610 000 FCFA
                                    </div>
                                </div>
                                <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                    <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                </div>
                            </div>

                            <!-- Ligne Kigali -->
                            <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; justify-content: space-between">
                                <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                    <strong>Préparation à la certification Project Management Professional PMP®</strong> à <strong>Kigali</strong> du 01 au 12 Déc 2025
                                    <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                        Formation - coaching - simulateur - frais d'exam • Code: IVTPMP • 1 610 000 FCFA
                                    </div>
                                </div>
                                <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                    <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                </div>
                            </div>

                        </div>
                    </div>

                       <!-- Tableau des autres formations - VERSION RESPONSIVE -->
                        <div style="margin: 20px 0;">
                            <h3 style="color: #2c5aa0; margin-bottom: 15px;">Consultez également nos autres formations à venir</h3>
                            
                            <div style="background: #ffffff; border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden;">
                                
                                <!-- Ligne CAPM -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Préparation à la certification Certified Associate in Project Management (CAPM)®</strong> à <strong>Cotonou</strong> du 06 au 10 avr 2026 et du 03 au 07 août 2026
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation - coaching - simulateur - frais d'exam • Code: INTCAPM • 1 120 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne PMO -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Préparation à la certification PMI® PMO Certified Professional (PMI-PMOCP)™</strong> en <strong>Virtuel</strong> à la demande
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation - coaching - simulateur - frais d'exam • Code: IVTPMO
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne RMP -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Préparation à la certification PMI Risk Management Professional (PMI-RMP)®</strong> en <strong>Virtuel</strong> à la demande
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation - coaching - simulateur - frais d'exam • Code: IVTRMP
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne ACP -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Préparation à la certification PMI Agile Certified Practitioner (PMI-ACP)®</strong> en <strong>Virtuel</strong> à la demande
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation - coaching - simulateur - frais d'exam • Code: IVTACP • 1 120 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne PSM -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Préparation à la certification Professional Scrum Master™ I (PSM I)</strong> à <strong>Cotonou</strong> du 13 au 17 avr 2026 et du 07 au 11 déc 2026
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation - coaching - simulateur - frais d'exam • Code: IVTPSM • 1 120 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne Périmètre -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Gestion du périmètre et des modification dans les environnements bâtis</strong> en <strong>Virtuel</strong> à la demande
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation • Code: IVTNC3 • 185 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne Contrats -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Gestion des contrats et des risques dans les environnements batis</strong> en <strong>Virtuel</strong> à la demande
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation • Code: IVTNC4 • 185 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne MS Project -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Microsoft Project : Planification et suivi de projets</strong> à <strong>Cotonou</strong> du 03 au 05 mar 2026, du 07 au 09 juil 2026 et du 03 au 05 nov 2026
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation • Code: IVTNCO1 • 850 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne Primavera -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Primavera P6 : Planification et suivi de projets</strong> à <strong>Cotonou</strong> du 10 au 12 mar 2026, du 14 au 16 juil 2026 et du 10 au 12 nov 2026
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation • Code: IVTNCO2 • 850 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne JIRA -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px; border-bottom: 1px solid #f0f0f0; justify-content: space-between">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>JIRA : Planification et suivi de projets</strong> à <strong>Cotonou</strong> du 17 au 19 mar 2026, du 21 au 23 juil 2026 et du 17 au 19 nov 2026
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation • Code: IVTNCO3 • 850 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                                <!-- Ligne Power BI -->
                                <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 12px 10px;">
                                    <div style="flex: 1 1 300px; min-width: 200px; font-size: 13px; color: #333; padding: 5px 0;">
                                        <strong>Microsoft Power BI : Visualisation de données projets</strong> à <strong>Cotonou</strong> du 23 au 26 mar 2026, du 27 au 30 juil 2026 et du 23 au 26 nov 2026
                                        <div style="font-size: 11px; color: #666; margin-top: 2px;">
                                            Formation • Code: IVTNCO4 • 850 000 FCFA
                                        </div>
                                    </div>
                                    <div style="flex: 0 0 80px; text-align: center; padding: 5px 0;">
                                        <a href="https://inovact.com/preparation-au-pmp/" style="background-color: #28a745; color: white; padding: 6px 10px; text-decoration: none; border-radius: 4px; font-size: 11px; display: inline-block; white-space: nowrap;">S'inscrire</a>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- Signature -->
                        <div style="margin-top: 10px; margin-bottom: 10px;">
                            <span style="">Bien à vous,</span><br>
                            <span style="">L'équipe INOVACT Training</span>
                        </div>
                        <i style="margin-bottom: 10px; text-align: justify; display: block; font-size: 6px;">
                            Votre adresse électronique est collectée et traitée par INOVACT pour vous informer sur nos offres de formation et vous accompagner dans votre parcours de certification. En application de la loi 2017-20 portant code du numérique en République du Bénin, sur la protection des données à caractère personnel, vous pouvez vous désabonner ou exercer vos droits d'accès, d'opposition, de rectification et de suppression en envoyant un mail au info@inovact.com.
                            ou consultez notre <a href='https://inovact.com/politique-confidentialite.html'>politique de confidentialité</a>.
                        </i>
                    </div>
                    
<div style="text-align: center; padding: 10px 0; background-color: #f8f9fa; border-bottom: 1px solid #e0e0e0;">
    <a href="${URL_DE_LA_VERSION_WEB}" style="color: #666; font-size: 12px; text-decoration: none;">
        View this email in your browser
    </a>
</div>
                    <div style="font-family: Arial, sans-serif; max-width: 650px; margin: 0; background: #ffffff;">
                        <!-- Pied de page -->
                        <div style="background-color: #f8f8f8; border-top: 1px solid #e0e0e0;">
                            <div style="background-color: #555555; color: #ffffff; padding: 8px 0; font-size: 8px; text-align: center; margin: 0;">
                                INOVACT est agréée Authorized Training Partner par le PMI sous le n°4503 et Centre de formation qualifié par le FODEFCA sous le n°150D28
                            </div>
                            
                            <div style="max-width: 650px; margin: 0 auto; padding: 10px 8px;">
                                <div style="display: flex; justify-content: space-between; margin: 0;">
                                    <!-- Colonne gauche - Coordonnées générales -->
                                    <div style="flex: 1 1 180px; min-width: 150px; text-align: left; font-size: 12px; color: #555555; line-height: 1.3; margin: 0;">
                                        <strong>072 BP 369 Ste Rita</strong><br>
                                        <a href="mailto:info@inovact.com" style="color: #2c5aa0; text-decoration: none;">info@inovact.com</a><br>
                                        <a href="http://www.inovact.com" style="color: #2c5aa0; text-decoration: none;">www.inovact.com</a><br>
                                        <div style="margin-top: 3px;">
                                            <a href="https://www.facebook.com/inovact/" style="margin-right: 2px; display: inline-block;">
                                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/2023_Facebook_icon.svg/640px-2023_Facebook_icon.svg.png" alt="Facebook" style="border: 0;" width="14" height="14">
                                            </a>
                                            <a href="https://x.com/Inovact_Sarl" style="margin-right: 2px; display: inline-block;">
                                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/X_%28formerly_Twitter%29_logo_late_2025.svg/640px-X_%28formerly_Twitter%29_logo_late_2025.svg.png" alt="Twitter" style="border: 0;" width="14" height="14">
                                            </a>
                                            <a href="https://www.linkedin.com/company/inovact" style="margin-right: 2px; display: inline-block;">
                                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/LinkedIn_PNG16.png/640px-LinkedIn_PNG16.png" alt="LinkedIn" style="border: 0;" width="14" height="14">
                                            </a>
                                        </div>
                                    </div>

                                    <!-- Colonne centre - Bénin -->
                                    <div style="flex: 1 1 180px; min-width: 150px; text-align: left; font-size: 12px; color: #555555; line-height: 1.3; margin: 0;">
                                        <strong style="color: #2c5aa0;">BÉNIN</strong><br>
                                        63, rue 6.130 Cotonou<br>
                                        TEL : (+229) 58585050<br>
                                        IFU : 3201300728018
                                    </div>

                                    <!-- Colonne droite - Togo -->
                                    <div style="flex: 1 1 180px; min-width: 180px; text-align: left; font-size: 12px; color: #555555; line-height: 1.3; margin: 0;">
                                        <strong style="color: #2c5aa0;">TOGO</strong><br>
                                        Rue KEMENVI, 50 Tokoin, Lomé<br>
                                        TEL : (+228) 71647777<br>
                                        NIF : 1001975332
                                    </div>
                                    
                                    <!-- Colonne certifications -->
                                    <div style="flex: 1 1 180px; min-width: 150px; text-align: right; color: #555555; line-height: 1.3; margin: 0;">
                                        <img src="https://api-etrainapp.ivtapp.com/static/acces_app/pmi-authorized-logo.png" alt="PMI Premier Authorized Training Partner" style="width: 60px; height: auto;">
                                        <img src="https://testapi-etrainapp.ivtapp.com/static/acces_app/SCRUMstudy-ATP - Logo.png" alt="SCRUMstudy Authorized Training Partner" style="width: 60px; height: auto; margin-left: 10px">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            `
        },
        {
            id: 2,
            nom: "Template Professionnel",
            description: "Design épuré et professionnel",
            html: `
                <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; background: #ffffff;">
                    <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 30px; text-align: center; color: white;">
                        <h1 style="margin: 0; font-size: 28px; font-weight: bold;">VOTRE LOGO</h1>
                        <p style="margin: 10px 0 0 0; font-size: 16px; opacity: 0.9;">Plateforme eTrainApp</p>
                    </div>
                    
                    <div style="padding: 40px 30px; background: #f8f9fa;">
                        <h2 style="color: #333; margin-bottom: 20px;">Titre Principal</h2>
                        <p style="color: #666; line-height: 1.6; margin-bottom: 20px;">
                            Bonjour cher apprenant,<br><br>
                            Nous sommes ravis de vous partager les dernières nouvelles et mises à jour.
                        </p>
                        
                        <div style="background: white; padding: 25px; border-radius: 8px; border-left: 4px solid #667eea; margin: 25px 0;">
                            <h3 style="color: #333; margin-top: 0;">Point Important</h3>
                            <p style="color: #666; line-height: 1.6; margin: 0;">
                                Ceci est un point important que vous souhaitez mettre en avant.
                            </p>
                        </div>
                        
                        <div style="text-align: center; margin: 30px 0;">
                            <a href="#" style="background: #667eea; color: white; padding: 12px 30px; text-decoration: none; border-radius: 5px; display: inline-block; font-weight: bold;">
                                Appel à l'action
                            </a>
                        </div>
                    </div>
                    
                    <div style="background: #2c3e50; color: white; padding: 20px; text-align: center;">
                        <p style="margin: 0; font-size: 14px;">
                            © 2024 eTrainApp. Tous droits réservés.<br>
                            <a href="#" style="color: #ecf0f1; text-decoration: none;">Se désabonner</a>
                        </p>
                    </div>
                </div>
            `
        },
        {
            id: 3,
            nom: "Template Moderne",
            description: "Design moderne avec cartes",
            html: `
                <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 650px; margin: 0 auto;">
                    <!-- Header -->
                    <div style="background: #ffffff; padding: 30px; text-align: center; border-bottom: 3px solid #e74c3c;">
                        <h1 style="color: #2c3e50; margin: 0; font-size: 32px; font-weight: 300;">
                            eTrain<span style="font-weight: bold;">App</span>
                        </h1>
                        <p style="color: #7f8c8d; margin: 10px 0 0 0; font-size: 16px;">Votre partenaire formation</p>
                    </div>

                    <!-- Content -->
                    <div style="padding: 40px; background: #ecf0f1;">
                        <h2 style="color: #2c3e50; text-align: center; margin-bottom: 30px;">Nouveautés Excitées</h2>
                        
                        <!-- Feature Cards -->
                        <div style="display: flex; gap: 20px; margin-bottom: 30px;">
                            <div style="flex: 1; background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                                <h3 style="color: #e74c3c; margin-top: 0;">🚀 Nouvelle Fonctionnalité</h3>
                                <p style="color: #34495e; line-height: 1.5;">
                                    Découvrez notre dernière innovation conçue pour améliorer votre expérience.
                                </p>
                            </div>
                            <div style="flex: 1; background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                                <h3 style="color: #3498db; margin-top: 0;">📊 Analytics Avancés</h3>
                                <p style="color: #34495e; line-height: 1.5;">
                                    Suivez vos progrès avec nos nouveaux tableaux de bord détaillés.
                                </p>
                            </div>
                        </div>

                        <!-- CTA -->
                        <div style="text-align: center; background: white; padding: 30px; border-radius: 10px;">
                            <h3 style="color: #2c3e50; margin-top: 0;">Prêt à commencer ?</h3>
                            <a href="#" style="background: linear-gradient(45deg, #e74c3c, #c0392b); color: white; padding: 15px 40px; text-decoration: none; border-radius: 25px; display: inline-block; font-weight: bold; font-size: 16px;">
                                Explorer Maintenant
                            </a>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div style="background: #34495e; color: #bdc3c7; padding: 25px; text-align: center;">
                        <p style="margin: 0 0 10px 0;">
                            <a href="#" style="color: #ecf0f1; text-decoration: none; margin: 0 10px;">Contact</a> • 
                            <a href="#" style="color: #ecf0f1; text-decoration: none; margin: 0 10px;">Aide</a> • 
                            <a href="#" style="color: #ecf0f1; text-decoration: none; margin: 0 10px;">Confidentialité</a>
                        </p>
                        <p style="margin: 0; font-size: 12px;">
                            © 2024 eTrainApp. Si vous ne souhaitez plus recevoir ces emails, <a href="#" style="color: #ecf0f1;">cliquez ici</a>.
                        </p>
                    </div>
                </div>
            `
        },
        {
            id: 4,
            nom: "Template Simple",
            description: "Design simple et efficace",
            html: `
                <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #ddd;">
                    <!-- Header -->
                    <div style="background: #f8f9fa; padding: 20px; text-align: center; border-bottom: 1px solid #dee2e6;">
                        <h2 style="color: #495057; margin: 0;">Communication Importante</h2>
                    </div>

                    <!-- Content -->
                    <div style="padding: 30px;">
                        <p style="color: #6c757d; line-height: 1.6; margin-bottom: 20px;">
                            Cher utilisateur,
                        </p>
                        
                        <p style="color: #495057; line-height: 1.6; margin-bottom: 20px;">
                            Nous souhaitons vous informer d'une mise à jour importante concernant notre plateforme.
                        </p>

                        <div style="background: #e9ecef; padding: 15px; border-radius: 5px; margin: 20px 0;">
                            <strong>Information clé :</strong> Cette section met en avant les points les plus importants de votre message.
                        </div>

                        <p style="color: #495057; line-height: 1.6;">
                            Pour toute question, n'hésitez pas à nous contacter.
                        </p>

                        <p style="color: #6c757d; line-height: 1.6; margin-top: 30px;">
                            Cordialement,<br>
                            <strong>L'équipe eTrainApp</strong>
                        </p>
                    </div>

                    <!-- Footer -->
                    <div style="background: #343a40; color: #fff; padding: 15px; text-align: center; font-size: 12px;">
                        <p style="margin: 0;">
                            eTrainApp • contact@etrainapp.com • etrainapp.ivtapp.com
                        </p>
                    </div>
                </div>
            `
        },
        {
            id: 5,
            nom: "PMP Formation 2026",
            description: "Template moderne pour annonce de formation PMP",
            html: `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <style>
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.03); }
                    100% { transform: scale(1); }
                }
                .animated { animation: fadeIn 0.6s ease-out; }
                .btn:hover { transform: scale(1.02); box-shadow: 0 6px 20px rgba(255,107,53,0.4); }
            </style>
        </head>
        <body
    style="margin: 0; padding: 0; background-color: #f0f2f5; font-family: 'Segoe UI', Arial, sans-serif; line-height: 1.4;">
    <div
        style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">

        <!-- Contenu principal -->
        <div style="padding: 20px 15px;" class="animated">

            <!-- BANNIÈRE AVEC IMAGE -->
            <div class="hero">
                <img src="banis.png" alt="Bannière INOVACT - Certification PMP 2026"
                    style="width:100%; max-width:600px; height:auto; display:block; border-radius:20px">
            </div>

            <!-- Salutation personnalisée -->
            <p style="color: #2c3e50; font-size: 16px; line-height: 1.5; margin-bottom: 20px; margin-top: 20px;">
                Cher(e) <strong style="color: #1a4d8c;">{utilisateur}</strong>,
            </p>

            <!-- Introduction -->
            <p style="color: #4a5568; font-size: 15px; line-height: 1.6; margin-bottom: 20px;">
                Dans un environnement de plus en plus orienté résultats, l'expérience seule ne suffit plus.
                Les entreprises accordent désormais une forte valeur aux compétences certifiées en management
                et recherchent des professionnels capables de piloter des projets avec méthode, leadership et impact.
            </p>

            <p style="color: #4a5568; font-size: 15px; line-height: 1.6; margin-bottom: 25px;">
                C'est dans cette dynamique qu'<strong>INOVACT, Authorized Training Partner du PMI</strong>, lance sa
                nouvelle
                session de préparation à la <strong>certification PMP® Version 2026</strong>.
            </p>

            <!-- Section points forts -->
            <div style="background: #f8fafc; border-radius: 12px; padding: 20px; margin: 25px 0;">
                <h3 style="color: #1a4d8c; margin: 0 0 15px 0; font-size: 18px;">Cette formation vous permettra de :
                </h3>

                <table width="100%" cellpadding="0" cellspacing="0" border="0"
                    style="border: none; border-collapse: collapse;">
                    <tr>
                        <td style="padding: 6px 22px; border: none;"><span
                                style="display: inline-block; width: 20px; height: 20px; background: #2c5aa0; border-radius: 50%; text-align: center; line-height: 20px; color: white; font-size: 12px; margin-right: 10px;">✓</span>
                            <span style="color: #2d3748; font-size: 15px;">Renforcer vos compétences en gestion et
                                pilotage de
                                projets</span></td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 22px; border: none;"><span
                                style="display: inline-block; width: 20px; height: 20px; background: #2c5aa0; border-radius: 50%; text-align: center; line-height: 20px; color: white; font-size: 12px; margin-right: 10px;">✓</span>
                            <span style="color: #2d3748;font-size: 15px;">Maîtriser les approches prédictives, agiles et
                                hybrides</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 22px; border: none;"><span
                                style="display: inline-block; width: 20px; height: 20px; background: #2c5aa0; border-radius: 50%; text-align: center; line-height: 20px; color: white; font-size: 12px; margin-right: 10px;">✓</span>
                            <span style="color: #2d3748; font-size: 15px;">Vous entraîner à travers des examens blancs et
                                des QCM
                                pratiques</span></td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 22px; border: none;"><span
                                style="display: inline-block; width: 20px; height: 20px; background: #2c5aa0; border-radius: 50%; text-align: center; line-height: 20px; color: white; font-size: 12px; margin-right: 10px;">✓</span>
                            <span style="color: #2d3748; font-size: 15px;">Bénéficier d'un accompagnement à l'éligibilité
                                PMP®</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 22px; border: none;"><span
                                style="display: inline-block; width: 20px; height: 20px; background: #2c5aa0; border-radius: 50%; text-align: center; line-height: 20px; color: white; font-size: 12px; margin-right: 10px;">✓</span>
                            <span style="color: #2d3748; font-size: 15px;">Développer une méthodologie reconnue à
                                l'international</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 22px; border: none;"><span
                                style="display: inline-block; width: 20px; height: 20px; background: #2c5aa0; border-radius: 50%; text-align: center; line-height: 20px; color: white; font-size: 12px; margin-right: 10px;">✓</span>
                            <span style="color: #2d3748; font-size: 15px;">Valoriser durablement votre profil
                                professionnel</span></td>
                    </tr>
                </table>
            </div>

            <!-- Message de motivation -->
            <p style="color: #4a5568; font-size: 15px; line-height: 1.6; margin: 20px 0; font-style: italic;">
                "Que vous souhaitiez évoluer, renforcer votre crédibilité professionnelle ou accéder à de nouvelles
                opportunités,
                la certification PMP® constitue pour vous un véritable accélérateur de carrière."
            </p>

            <!-- Bouton CTA principal -->
            <div style="text-align: center; margin: 15px 0 15px;">
                <a href="https://inovact.com/preparation-au-pmp/" class="btn"
                    style="background: linear-gradient(135deg, #94bf3e 0%, #5c7e1a 100%); 
                        color: white; 
                        padding: 14px 40px; 
                        text-decoration: none; 
                        border-radius: 50px; 
                        display: inline-block; 
                        font-weight: bold; 
                        font-size: 16px;
                        box-shadow: 0 4px 12px rgba(148,191,62,0.3);
                        transition: all 0.3s ease;">
                    En savoir plus
                </a>
            </div>
        </div>

        <div style="text-align: center; padding: 10px 0; background-color: #f8f9fa; border-bottom: 1px solid #e0e0e0;">
    <a href="${URL_DE_LA_VERSION_WEB1}" style="color: #666; font-size: 12px; text-decoration: none;">
        View this email in your browser
    </a>
</div>

        <!-- Footer -->
        <div style="background: #1a202c; padding: 25px;">

            <!-- Ligne avec coordonnées à gauche et images à droite -->
            <table width="100%" cellpadding="0" cellspacing="0" border="0"
                style="border: none; border-collapse: collapse;">
                <tr>
                    <!-- Coordonnées gauche -->
                    <td width="50%" style="text-align: left; vertical-align: top; border: none;">
                        <p
                            style="color: #fafafa; font-size: 13px; margin: 0 0 8px 0; letter-spacing: 1px; font-weight: bold;">
                            Pour plus d'informations :</p>

                        <!-- Téléphone avec icône WhatsApp -->
                        <div class="footer-line" style="margin-bottom: 6px;">
                            <img src="whatsapp.png" alt="WhatsApp" style="height: 16px; width: auto; display: inline-block; vertical-align: middle;">
                            <div style="display: inline-block; vertical-align: middle;">
                                <span style="color: #a0aec0; font-size: 12px; display: block;">+229 01 58 58 50 50</span>
                                <span style="color: #a0aec0; font-size: 12px; display: block;">+228 71 64 77 77</span>
                            </div>
                        </div>

                        <!-- Email avec icône (correction de l'alignement) -->
                        <div class="footer-line" style="margin-top: 4px;">
                            <img src="email.png" alt="Email" style="height: 16px; width: auto; display: inline-block; vertical-align: middle; margin-right: 4px;">
                            <a href="mailto:info@inovact.com"
                                style="color: #a0aec0; text-decoration: none; font-size: 12px; display: inline-block; vertical-align: middle; line-height: 1.4;">
                                info@inovact.com
                            </a>
                        </div>
                    </td>

                    <!-- Images droite -->
                    <td width="50%" style="text-align: right; vertical-align: top; border: none;">
                        <div style="display: flex; justify-content: flex-end; gap: 20px; align-items: flex-start;">
                            <div style="text-align: center;">
                                <img src="http://localhost:8000/static/acces_app/pmi-authorized-logo.png" alt="PMI ATP"
                                    style="height: 45px; display: block;">
                            </div>
                            <div style="text-align: center;">
                                <img src="https://testapi-etrainapp.ivtapp.com/static/acces_app/SCRUMstudy-ATP%20-%20Logo.png"
                                    alt="SCRUMstudy" style="height: 44px; display: block;">
                            </div>
                        </div>
                    </td>
                </tr>
            </table>

            <!-- Mentions légales -->
            <p style="color: #a0aec0; font-size: 10px; margin: 25px 0 5px 0; text-align: center;">
                INOVACT est agréée Authorized Training Partner par le PMI
            </p>
            <p style="color: #a0aec0; font-size: 9px; margin: 0; text-align: center;">
                PMP® and the PMI Authorized Training Partner logo are registered marks of the Project Management
                Institute Inc.
            </p>
        </div>
    </div>
</body>
        </html>
    `
        }
    ];

    const handleMenuClick = (menu) => {
        setActiveMenu(menu);
        if (menu === 'mail') {
            setSelectedNewsletter(null);
        }
    };

    const handleNewsletterClick = (newsletter) => {
        setSelectedNewsletter(newsletter);
        setContenuNewsletter(newsletter.contenu);
    };

    // Fonction pour afficher les alertes
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });

        // Faire défiler vers le haut
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // défilement fluide
        });

        setTimeout(() => setAlert({ message: '', type: '' }), 5000);
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };



    const [showImportModal, setShowImportModal] = useState(false);
    const [importLoading, setImportLoading] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [paysImport, setPaysImport] = useState('Bénin');


    const handleImportExcel = async () => {
        if (!importFile) {
            showAlert('Veuillez sélectionner un fichier Excel', 'danger');
            return;
        }

        const formData = new FormData();
        formData.append('file', importFile);
        formData.append('pays', paysImport);

        setImportLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/importer-numeros-excel/`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (response.ok && data.numeros) {
                // Convertir les numéros en format pour Select
                const nouveauxNumeros = data.numeros
                    .filter(numero => numero) // Filtrer les valeurs nulles/vides
                    .map(numero => ({
                        value: numero,
                        label: numero
                    }));

                // Ajouter aux destinataires existants (sans doublons)
                const numerosExistants = destinatairesSMS.map(d => d.value);
                const numerosUniques = nouveauxNumeros.filter(n =>
                    !numerosExistants.includes(n.value)
                );

                if (numerosUniques.length > 0) {
                    setDestinatairesSMS([...destinatairesSMS, ...numerosUniques]);
                    showAlert(`${numerosUniques.length} numéro(s) importé(s) avec succès`);
                    setShowImportModal(false);
                    setImportFile(null);
                } else {
                    showAlert('Aucun nouveau numéro valide trouvé dans le fichier', 'warning');
                }
            } else {
                showAlert(data.error || 'Erreur lors de l\'importation', 'danger');
            }
        } catch (error) {
            console.error('Erreur d\'importation:', error);
            showAlert('Erreur réseau lors de l\'importation', 'danger');
        } finally {
            setImportLoading(false);
        }
    };




    const [showImportEmailModal, setShowImportEmailModal] = useState(false);
    const [importEmailLoading, setImportEmailLoading] = useState(false);
    const [importEmailFile, setImportEmailFile] = useState(null);

    const handleImportExcelEmail = async () => {
        if (!importEmailFile) {
            showAlert('Veuillez sélectionner un fichier Excel', 'danger');
            return;
        }

        const formData = new FormData();
        formData.append('file', importEmailFile);

        setImportEmailLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/importer-emails-excel/`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (response.ok && data.contacts) {
                // Convertir les contacts en format pour Select
                const nouveauxContacts = data.contacts
                    .filter(contact => contact.email && validateEmail(contact.email))
                    .map(contact => ({
                        value: contact.email,
                        label: contact.display || contact.email,
                        nom: contact.nom,
                        email: contact.email
                    }));

                // Ajouter aux destinataires existants (sans doublons)
                const emailsExistants = destinataire.map(d => d.value);
                const contactsUniques = nouveauxContacts.filter(contact =>
                    !emailsExistants.includes(contact.value)
                );

                if (contactsUniques.length > 0) {
                    setDestinataire([...destinataire, ...contactsUniques]);
                    showAlert(`${contactsUniques.length} contact(s) importé(s) avec succès (${data.summary?.avec_nom || 0} avec nom)`);
                    setShowImportEmailModal(false);
                    setImportEmailFile(null);
                } else {
                    showAlert('Aucun nouveau contact valide trouvé dans le fichier', 'warning');
                }
            } else {
                showAlert(data.error || 'Erreur lors de l\'importation des contacts', 'danger');
            }
        } catch (error) {
            console.error('Erreur d\'importation:', error);
            showAlert('Erreur réseau lors de l\'importation', 'danger');
        } finally {
            setImportEmailLoading(false);
        }
    };

    // Fonction de validation d'email
    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    // Fonction pour sauvegarder une newsletter

    const [estProgrammee, setEstProgrammee] = useState(false);
    const [frequence, setFrequence] = useState('');
    const [dateProgrammation, setDateProgrammation] = useState('');

    const handleSauvegarder = async () => {
        // Validation des champs selon le type de destinataire
        if (typeDestinataire === 'utilisateur' && !destinataire.length) {
            showAlert('Veuillez sélectionner au moins un destinataire', 'danger');
            return;
        }
        if (typeDestinataire === 'groupe' && !groupesDestinataire.length) {
            showAlert('Veuillez sélectionner au moins un groupe', 'danger');
            return;
        }
        if (!objet.trim()) {
            showAlert('Veuillez saisir l\'objet', 'danger');
            return;
        }
        if (!contenuNewsletter.trim()) {
            showAlert('Veuillez saisir le contenu de la newsletter', 'danger');
            return;
        }
        if (estProgrammee && (!frequence || !dateProgrammation)) {
            showAlert('Veuillez sélectionner la fréquence et la date de programmation', 'danger');
            return;
        }

        setIsLoading(true);
        try {
            const dataToSend = {
                objet: objet,
                user_id: user_id,
                contenu: contenuNewsletter,
                type_destinataire: typeDestinataire,
                statut: estProgrammee ? 'programmee' : 'brouillon'
            };

            // Ajouter les données selon le type de destinataire
            if (typeDestinataire === 'utilisateur') {
                dataToSend.destinataires = destinataire.map(d => d.value);
            } else if (typeDestinataire === 'groupe') {
                dataToSend.groupes = groupesDestinataire.map(g => g.value);
                dataToSend.destinataires = []; // Liste vide car les emails seront récupérés côté serveur
            }

            // Ajouter les champs de programmation si programmée
            if (estProgrammee) {
                dataToSend.frequence = frequence;
                dataToSend.date_programmation = dateProgrammation;
                dataToSend.statut = 'programmee';
            }

            const response = await fetch(process.env.REACT_APP_HOTE + '/enregistrer-newsletter/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend)
            });

            const data = await response.json();

            if (response.ok) {
                showAlert(estProgrammee ?
                    'Newsletter programmée avec succès !' :
                    'Newsletter sauvegardée avec succès !'
                );
                // Réinitialiser le formulaire
                setObjet('');
                setContenuNewsletter('');
                setDestinataire([]);
                setGroupesDestinataire([]);
                setEstProgrammee(false);
                setFrequence('');
                setDateProgrammation('');
                setTypeDestinataire('utilisateur');
                // Recharger la liste des newsletters
                fetchNewsletters();
                setActiveMenu('courriels');
            } else {
                showAlert(data.error || 'Erreur lors de la sauvegarde', 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur réseau lors de la sauvegarde', 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    // Modifiez la fonction handleEnvoyer pour inclure la programmation
    const handleEnvoyer = async () => {
        // Validation des champs selon le type de destinataire
        if (typeDestinataire === 'utilisateur' && !destinataire.length) {
            showAlert('Veuillez sélectionner au moins un destinataire', 'danger');
            return;
        }
        if (typeDestinataire === 'groupe' && !groupesDestinataire.length) {
            showAlert('Veuillez sélectionner au moins un groupe', 'danger');
            return;
        }
        if (!objet.trim()) {
            showAlert('Veuillez saisir l\'objet', 'danger');
            return;
        }
        if (!contenuNewsletter.trim()) {
            showAlert('Veuillez saisir le contenu de la newsletter', 'danger');
            return;
        }
        if (estProgrammee && (!frequence || !dateProgrammation)) {
            showAlert('Veuillez sélectionner la fréquence et la date de programmation', 'danger');
            return;
        }

        setIsLoading(true);
        try {
            const dataToSend = {
                objet: objet,
                contenu: contenuNewsletter,
                user_id: user_id,
                type_destinataire: typeDestinataire
            };

            // Ajouter les données selon le type de destinataire
            if (typeDestinataire === 'utilisateur') {
                const contactsDetails = destinataire.map(d => ({
                    email: d.value,
                    nom: d.nom || '' // Récupérer le nom si disponible
                }));

                dataToSend.destinataires = destinataire.map(d => d.value);
                dataToSend.contacts_details = contactsDetails; // Envoyer les noms aussi
            } else if (typeDestinataire === 'groupe') {
                dataToSend.groupes = groupesDestinataire.map(g => g.value);
                dataToSend.destinataires = []; // Liste vide car les emails seront récupérés côté serveur
            }

            // Ajouter les champs de programmation si programmée
            if (estProgrammee) {
                dataToSend.frequence = frequence;
                dataToSend.date_programmation = dateProgrammation;
                dataToSend.statut = 'programmee';
            }

            const endpoint = estProgrammee ?
                '/programmer-newsletter/' :
                '/envoyer-newsletter-direct/';

            const response = await fetch(process.env.REACT_APP_HOTE + endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend)
            });

            const data = await response.json();

            if (response.ok) {
                if (estProgrammee) {
                    showAlert('Newsletter programmée avec succès !');
                } else {
                    showAlert(`Newsletter envoyée ! ${data.statistiques.emails_envoyes} email(s) envoyé(s) sur ${data.statistiques.total_destinataires}`);
                }
                // Réinitialiser le formulaire
                setObjet('');
                setContenuNewsletter('');
                setDestinataire([]);
                setGroupesDestinataire([]);
                setEstProgrammee(false);
                setFrequence('');
                setDateProgrammation('');
                setTypeDestinataire('utilisateur');
                // Recharger la liste des newsletters
                fetchNewsletters();
                setActiveMenu('courriels');
            } else {
                showAlert(data.error || `Erreur lors de ${estProgrammee ? 'la programmation' : "l'envoi"}`, 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert(`Erreur réseau lors de ${estProgrammee ? 'la programmation' : "l'envoi"}`, 'danger');
        } finally {
            setIsLoading(false);
        }
    };


    const [showSendModal, setShowSendModal] = useState(false);
    const [newsletterToSend, setNewsletterToSend] = useState(null);

    // Fonctions pour gérer le modal d'envoi
    const handleShowSendModal = (newsletter) => {
        setNewsletterToSend(newsletter);
        setShowSendModal(true);
    };

    const handleCloseSendModal = () => {
        setShowSendModal(false);
        setNewsletterToSend(null);
    };

    // Modifiez la fonction handleEnvoyerNewsletterExistante
    const handleEnvoyerNewsletterExistante = async () => {
        if (!newsletterToSend) return;

        setIsLoading(true);
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/envoyer-newsletter-id/${newsletterToSend.id}/${user_id}/`, {
                method: 'POST'
            });

            const data = await response.json();

            if (response.ok) {
                showAlert(`Newsletter envoyée ! ${data.statistiques.emails_envoyes} email(s) envoyé(s)`);
                // Recharger la liste des newsletters
                fetchNewsletters();
            } else {
                showAlert(data.error || 'Erreur lors de l\'envoi', 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur réseau lors de l\'envoi', 'danger');
        } finally {
            setIsLoading(false);
            handleCloseSendModal();
        }
    };

    const handleTemplateSelect = (template) => {
        setContenuNewsletter(template.html);
        setShowTemplates(false);
    };

    // Fonction pour créer une option personnalisée
    const createOption = (label) => ({
        label,
        value: label,
    });

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const handleSupprimerNewsLetter = async () => {
        if (selectedNewsletter) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-newsletter/${selectedNewsletter.id}/${user_id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setShowDeleteModal(false);
                    fetchNewsletters();
                    showAlert("Étude supprimée avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de l\'étude');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
                fetchNewsletters();
            }
        }
    };

    // Gestionnaire pour les nouvelles entrées
    const handleInputChange = (inputValue, { action }) => {
        if (action === 'create-option') {
            const newOption = createOption(inputValue);
            setDestinataire([...destinataire, newOption]);
        }
    };





    // Ajoutez ces états pour le SMS
    const [contenuSMS, setContenuSMS] = useState('');
    const [destinatairesSMS, setDestinatairesSMS] = useState([]);
    const [typeDestinataireSMS, setTypeDestinataireSMS] = useState('utilisateur');
    const [groupesDestinataireSMS, setGroupesDestinataireSMS] = useState([]);

    // Ajoutez cette fonction pour envoyer le SMS
    const handleEnvoyerSMS = async () => {
        // Validation des champs
        if (typeDestinataireSMS === 'utilisateur' && !destinatairesSMS.length) {
            showAlert('Veuillez sélectionner au moins un destinataire', 'danger');
            return;
        }
        if (typeDestinataireSMS === 'groupe' && !groupesDestinataireSMS.length) {
            showAlert('Veuillez sélectionner au moins un groupe', 'danger');
            return;
        }
        if (!contenuSMS.trim()) {
            showAlert('Veuillez saisir le contenu du SMS', 'danger');
            return;
        }

        setIsLoading(true);
        try {
            const dataToSend = {
                contenu: contenuSMS,
                user_id: user_id,
                type_destinataire: typeDestinataireSMS
            };

            // Ajouter les données selon le type de destinataire
            if (typeDestinataireSMS === 'utilisateur') {
                dataToSend.destinataires = destinatairesSMS.map(d => d.value);
            } else if (typeDestinataireSMS === 'groupe') {
                dataToSend.groupes = groupesDestinataireSMS.map(g => g.value);
            }

            const response = await fetch(process.env.REACT_APP_HOTE + '/envoyer-sms/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend)
            });

            const data = await response.json();

            if (response.ok) {
                showAlert(`SMS envoyé ! ${data.statistiques.sms_envoyes} SMS envoyé(s) sur ${data.statistiques.total_destinataires}`);
                // Réinitialiser le formulaire
                setContenuSMS('');
                setDestinatairesSMS([]);
                setGroupesDestinataireSMS([]);
                fetchNewsletters()
                setActiveMenu('courriels');
            } else {
                showAlert(data.error || 'Erreur lors de l\'envoi du SMS', 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur réseau lors de l\'envoi du SMS', 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaEnvelope size={25} className='mr-2' />
                                Gestion des Newsletters
                            </h2>
                            <small>Création et gestion des newsletters.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        <strong>Newsletters</strong>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex gap-3" style={{ minHeight: '600px' }}>
                                {/* Partie gauche - Menu (15%) */}
                                <div className="flex-grow-0 flex-shrink-0" style={{ width: '15%' }}>
                                    <div className="bg-light rounded border p-3 h-100">
                                        <div className="d-flex flex-column gap-2">
                                            <button
                                                className={`btn d-flex align-items-center text-left p-3 border ${activeMenu === 'sms'
                                                    ? 'btn-success text-white'
                                                    : 'btn-light text-dark'
                                                    }`}
                                                onClick={() => handleMenuClick('sms')}
                                                style={{ transition: 'all 0.3s ease' }}
                                            >
                                                <FaSms className="mr-1" />
                                                <span className="fw-medium">Rédiger SMS</span>
                                            </button>
                                            <button
                                                className={`btn d-flex align-items-center text-left p-3 border ${activeMenu === 'mail'
                                                    ? 'btn-success text-white'
                                                    : 'btn-light text-dark'
                                                    }`}
                                                onClick={() => handleMenuClick('mail')}
                                                style={{ transition: 'all 0.3s ease' }}
                                            >
                                                <FaEnvelope className="mr-1" />
                                                <span className="fw-medium">Rédiger mail</span>
                                            </button>
                                            <button
                                                className={`btn d-flex align-items-center text-left p-3 border ${activeMenu === 'courriels'
                                                    ? 'btn-success text-white'
                                                    : 'btn-light text-dark'
                                                    }`}
                                                onClick={() => handleMenuClick('courriels')}
                                                style={{ transition: 'all 0.3s ease' }}
                                            >
                                                <FaEnvelopeOpen className="mr-1" />
                                                <span className="fw-medium">Courriels</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Partie droite - Contenu (85%) */}
                                <div className="flex-grow-1 flex-shrink-0" style={{ width: '85%' }}>
                                    <div className="bg-white rounded border p-4 h-100">
                                        {activeMenu === 'sms' && (
                                            <div className="d-flex flex-column h-100">
                                                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                    <h4 className="mb-0 text-dark">Rédiger un SMS</h4>
                                                </div>

                                                {/* Champs pour le SMS */}
                                                <div className="row mb-3 g-3">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="form-label fw-semibold mb-2">Type de destinataire</label>
                                                            <select
                                                                className="form-control mb-3"
                                                                value={typeDestinataireSMS}
                                                                onChange={(e) => setTypeDestinataireSMS(e.target.value)}
                                                            >
                                                                <option value="utilisateur">Utilisateurs ou numéros personnalisés</option>
                                                                <option value="groupe">Groupe</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <label className="form-label fw-semibold mb-0">Destinataires</label>
                                                                {typeDestinataireSMS === 'utilisateur' && (
                                                                    <div className="d-flex gap-2">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-success"
                                                                            onClick={() => {
                                                                                // Sélectionner tous les utilisateurs existants
                                                                                if (destinatairesSMS.filter(d =>
                                                                                    utilisateursSms.some(u => u.value === d.value)
                                                                                ).length === utilisateursSms.length) {
                                                                                    // Désélectionner tous les utilisateurs, mais garder les numéros personnalisés
                                                                                    const numerosPersonnalises = destinatairesSMS.filter(d =>
                                                                                        !utilisateursSms.some(u => u.value === d.value)
                                                                                    );
                                                                                    setDestinatairesSMS([...numerosPersonnalises]);
                                                                                } else {
                                                                                    // Ajouter tous les utilisateurs, conserver les numéros personnalisés existants
                                                                                    const numerosPersonnalises = destinatairesSMS.filter(d =>
                                                                                        !utilisateursSms.some(u => u.value === d.value)
                                                                                    );
                                                                                    setDestinatairesSMS([...utilisateursSms, ...numerosPersonnalises]);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {destinatairesSMS.filter(d =>
                                                                                utilisateursSms.some(u => u.value === d.value)
                                                                            ).length === utilisateursSms.length
                                                                                ? "Tout désélectionner"
                                                                                : "Tout sélectionner"
                                                                            }
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-primary ml-2"
                                                                            onClick={() => setShowImportModal(true)}
                                                                        >
                                                                            📁 Importer Excel
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {typeDestinataireSMS === 'utilisateur' ? (
                                                                <Select
                                                                    components={animatedComponents}
                                                                    options={utilisateursSms}
                                                                    value={destinatairesSMS}
                                                                    onChange={(selectedOptions) => {
                                                                        // Mettre à jour la liste des destinataires
                                                                        setDestinatairesSMS(selectedOptions || []);
                                                                    }}
                                                                    onInputChange={(inputValue, { action }) => {
                                                                        if (action === 'input-change') {
                                                                            setCurrentInput(inputValue);
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        // Ajouter un numéro personnalisé quand l'utilisateur appuie sur Entrée
                                                                        if (e.key === 'Enter' && currentInput && currentInput.trim() !== '') {
                                                                            const newPhone = currentInput.trim();

                                                                            // Vérifier si c'est déjà dans la liste
                                                                            const alreadyExists = destinatairesSMS.some(item => item.value === newPhone) ||
                                                                                utilisateursSms.some(user => user.value === newPhone);

                                                                            if (!alreadyExists) {
                                                                                // Créer une nouvelle option
                                                                                const newOption = {
                                                                                    value: newPhone,
                                                                                    label: `📞 ${newPhone} (personnalisé)`
                                                                                };

                                                                                // Ajouter à la liste
                                                                                setDestinatairesSMS([...destinatairesSMS, newOption]);
                                                                                setCurrentInput('');
                                                                                e.preventDefault();
                                                                            }
                                                                        }
                                                                    }}
                                                                    isMulti
                                                                    isSearchable
                                                                    isClearable
                                                                    placeholder="Sélectionnez ou tapez des numéros (Appuyez sur Entrée pour ajouter)"
                                                                    noOptionsMessage={() => "Tapez un numéro et appuyez sur Entrée pour l'ajouter"}
                                                                    formatCreateLabel={(inputValue) => `Ajouter "${inputValue}"`}
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minHeight: '38px',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            backgroundColor: state.isSelected ? '#28a745' :
                                                                                state.isFocused ? '#e9ecef' : 'white',
                                                                            color: state.isSelected ? 'white' : '#495057',
                                                                        }),
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Select
                                                                    components={animatedComponents}
                                                                    options={groupes}
                                                                    value={groupesDestinataireSMS}
                                                                    onChange={setGroupesDestinataireSMS}
                                                                    isMulti
                                                                    isSearchable
                                                                    isClearable
                                                                    placeholder="Sélectionnez un ou plusieurs groupes"
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minHeight: '38px',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                />
                                                            )}

                                                            <div className="mt-1 text-muted small">
                                                                {typeDestinataireSMS === 'utilisateur' ? (
                                                                    <>
                                                                        <div>
                                                                            {destinatairesSMS.length} destinataire(s) sélectionné(s)
                                                                        </div>
                                                                        {/* <div className="text-info small mt-1">
                                                                            💡 Tapez un numéro et appuyez sur Entrée pour l'ajouter à la liste
                                                                        </div> */}
                                                                    </>
                                                                ) : (
                                                                    `${groupesDestinataireSMS.length} groupe(s) sélectionné(s)`
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="form-label fw-semibold mb-2">
                                                                Message SMS
                                                                <span className={`ml-2 float-right ${contenuSMS.length > 160 ? 'text-danger' : 'text-muted'}`}>
                                                                    {contenuSMS.length}/160 caractères
                                                                </span>
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                value={contenuSMS}
                                                                onChange={(e) => setContenuSMS(e.target.value)}
                                                                placeholder="Tapez votre message SMS ici"
                                                                rows="4"
                                                                style={{ resize: 'vertical' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bouton d'envoi */}
                                                <div className="d-flex justify-content-end gap-2 pt-3 border-top">
                                                    <button
                                                        className="btn btn-success d-flex align-items-center"
                                                        onClick={handleEnvoyerSMS}
                                                        disabled={isLoading || !contenuSMS.trim() || contenuSMS.length > 160 || destinatairesSMS.length === 0}
                                                    >
                                                        {isLoading ? (
                                                            <FaSpinner className="mr-1 fa-spin" />
                                                        ) : (
                                                            <FaSms className="mr-1" />
                                                        )}
                                                        {isLoading ? 'Envoi...' : "Envoyer le SMS"}
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        {activeMenu === 'mail' && (
                                            <div className="d-flex flex-column h-100">
                                                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                    <h4 className="mb-0 text-dark">Rédiger une newsletter</h4>
                                                    <button
                                                        className="btn btn-info d-flex align-items-center"
                                                        onClick={() => setShowTemplates(!showTemplates)}
                                                    >
                                                        <FaMagic className="mr-1" />
                                                        {showTemplates ? 'Masquer les templates' : 'Choisir un template'}
                                                    </button>
                                                </div>

                                                {/* Section Templates */}
                                                {showTemplates && (
                                                    <div className="mb-4 p-3 border rounded bg-light">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <h5 className="mb-0">Choisissez un template</h5>
                                                            <button
                                                                className="btn btn-sm btn-outline-secondary"
                                                                onClick={() => setShowTemplates(false)}
                                                            >
                                                                <FaTimes />
                                                            </button>
                                                        </div>
                                                        <div className="row g-3">
                                                            {templates.map(template => (
                                                                <div
                                                                    key={template.id}
                                                                    className="col-md-6 col-lg-3"
                                                                    onMouseEnter={() => setHoveredTemplate(template)}
                                                                    onMouseLeave={() => setHoveredTemplate(null)}
                                                                    style={{ position: 'relative' }}
                                                                >
                                                                    <div
                                                                        className="card h-100 border"
                                                                        style={{ transition: 'all 0.3s ease', cursor: 'pointer' }}
                                                                        onClick={() => handleTemplateSelect(template)}
                                                                    >
                                                                        <div className="card-body">
                                                                            <h6 className="card-title">{template.nom}</h6>
                                                                            <p className="card-text small text-muted">
                                                                                {template.description}
                                                                            </p>
                                                                        </div>
                                                                        <div className="card-footer bg-transparent border-top-0">
                                                                            <small className="text-success">👁️ Cliquer pour sélectionner</small>
                                                                        </div>
                                                                    </div>

                                                                    {/* Aperçu au survol */}
                                                                    {hoveredTemplate?.id === template.id && (
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                bottom: '100%',
                                                                                left: '0',
                                                                                right: '0',
                                                                                marginBottom: '10px',
                                                                                zIndex: 1050,
                                                                                backgroundColor: 'white',
                                                                                border: '1px solid #ddd',
                                                                                borderRadius: '8px',
                                                                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                                padding: '10px',
                                                                                maxHeight: '300px',
                                                                                overflow: 'auto'
                                                                            }}
                                                                        >
                                                                            <div style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '8px' }}>
                                                                                Aperçu rapide
                                                                            </div>
                                                                            <div
                                                                                style={{ fontSize: '10px' }}
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: template.html.substring(0, 300) + '...'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}



                                                {/* Nouveaux champs De, À, Objet */}
                                                <div className="row mb-3 g-3">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="form-label fw-semibold mb-2">De</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={expediteur}
                                                                onChange={(e) => setExpediteur(e.target.value)}
                                                                placeholder="Expéditeur"
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="form-label fw-semibold mb-2">Type de destinataire</label>
                                                            <select
                                                                className="form-control mb-3"
                                                                value={typeDestinataire}
                                                                onChange={(e) => setTypeDestinataire(e.target.value)}
                                                            >
                                                                <option value="utilisateur">Utilisateurs</option>
                                                                <option value="groupe">Groupe</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <label className="form-label fw-semibold mb-0">À</label>
                                                                {typeDestinataire === 'utilisateur' && (
                                                                    <div className="d-flex gap-2">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-success mr-2"
                                                                            onClick={() => {
                                                                                const utilisateursSelectionnes = destinataire.filter(d =>
                                                                                    utilisateurs.some(u => u.value === d.value)
                                                                                ).length;
                                                                                if (utilisateursSelectionnes === utilisateurs.length) {
                                                                                    const emailsPersonnalises = destinataire.filter(d =>
                                                                                        !utilisateurs.some(u => u.value === d.value)
                                                                                    );
                                                                                    setDestinataire([...emailsPersonnalises]);
                                                                                } else {
                                                                                    const emailsPersonnalises = destinataire.filter(d =>
                                                                                        !utilisateurs.some(u => u.value === d.value)
                                                                                    );
                                                                                    setDestinataire([...utilisateurs, ...emailsPersonnalises]);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {destinataire.filter(d => utilisateurs.some(u => u.value === d.value)).length === utilisateurs.length
                                                                                ? "Tout désélectionner"
                                                                                : "Tout sélectionner"
                                                                            }
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            onClick={() => setShowImportEmailModal(true)}
                                                                        >
                                                                            📁 Importer Excel
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {typeDestinataire === 'utilisateur' ? (
                                                                <div className="form-group">
                                                                    <Select
                                                                        components={animatedComponents}
                                                                        options={utilisateurs}
                                                                        value={destinataire}
                                                                        onChange={setDestinataire}
                                                                        onInputChange={(inputValue, { action }) => {
                                                                            if (action === 'input-change') {
                                                                                setCurrentInput(inputValue);
                                                                            }
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' && currentInput && currentInput.trim() !== '') {
                                                                                const newEmail = currentInput.trim();
                                                                                if (!destinataire.some(item => item.value === newEmail) &&
                                                                                    !utilisateurs.some(user => user.value === newEmail)) {
                                                                                    const newOption = {
                                                                                        value: newEmail,
                                                                                        label: newEmail, // Pour les emails manuels, pas de nom
                                                                                        email: newEmail,
                                                                                        nom: '' // Nom vide pour les emails manuels
                                                                                    };
                                                                                    setDestinataire([...destinataire, newOption]);
                                                                                    setCurrentInput('');
                                                                                    e.preventDefault();
                                                                                }
                                                                            }
                                                                        }}
                                                                        isMulti
                                                                        isSearchable
                                                                        isClearable
                                                                        placeholder="Sélectionnez ou tapez des emails (Appuyez sur Entrée pour ajouter)"
                                                                        noOptionsMessage={() => "Tapez un email et appuyez sur Entrée pour l'ajouter"}
                                                                        formatCreateLabel={(inputValue) => `Ajouter "${inputValue}"`}
                                                                        getOptionLabel={(option) => option.label || option.email}
                                                                        getOptionValue={(option) => option.value || option.email}
                                                                        styles={{
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                minHeight: '38px',
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            }),
                                                                            option: (base, state) => ({
                                                                                ...base,
                                                                                backgroundColor: state.isSelected ? '#28a745' :
                                                                                    state.isFocused ? '#e9ecef' : 'white',
                                                                                color: state.isSelected ? 'white' : '#495057',
                                                                            }),
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <Select
                                                                    components={animatedComponents}
                                                                    options={groupes}
                                                                    value={groupesDestinataire}
                                                                    onChange={setGroupesDestinataire}
                                                                    isMulti
                                                                    isSearchable
                                                                    isClearable
                                                                    placeholder="Sélectionnez un ou plusieurs groupes"
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minHeight: '38px',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                />
                                                            )}

                                                            <div className="mt-1 text-muted small">
                                                                {typeDestinataire === 'utilisateur'
                                                                    ? `${destinataire.length} destinataire(s) sélectionné(s)`
                                                                    : `${groupesDestinataire.length} groupe(s) sélectionné(s)`
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="form-label fw-semibold mb-2">Objet</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={objet}
                                                                onChange={(e) => setObjet(e.target.value)}
                                                                placeholder="Objet de la newsletter"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* AJOUTER CETTE SECTION POUR L'INFORMATION SUR LE MOT-CLÉ */}
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <div className="alert alert-info p-2 small">
                                                            <strong>💡 Astre de personnalisation :</strong> Utilisez le mot-clé <code className="bg-light px-1 rounded">{`{utilisateur}`}</code> dans votre contenu.
                                                            Il sera automatiquement remplacé par le <strong>nom et prénom</strong> de chaque destinataire pour une personnalisation individuelle.
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Éditeur Summernote */}
                                                <div className="flex-grow-1 mb-3" style={{ minHeight: '400px' }}>
                                                    <SummernoteEditorNewsLetters
                                                        value={contenuNewsletter}
                                                        onChange={setContenuNewsletter}
                                                    />
                                                </div>
                                                <div className="row mb-3 g-3">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="estProgrammee"
                                                                    checked={estProgrammee}
                                                                    onChange={(e) => setEstProgrammee(e.target.checked)}
                                                                />
                                                                <label className="form-check-label fw-semibold" htmlFor="estProgrammee">
                                                                    Programmer l'envoi
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {estProgrammee && (
                                                    <div className="row mb-3 g-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="form-label fw-semibold mb-2">Fréquence</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={frequence}
                                                                    onChange={(e) => setFrequence(e.target.value)}
                                                                    required
                                                                >
                                                                    <option value="">Sélectionnez une fréquence</option>
                                                                    <option value="jour">Par jour</option>
                                                                    <option value="semaine">Par semaine</option>
                                                                    <option value="mois">Par mois</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="form-label fw-semibold mb-2">Date de lancement</label>
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control"
                                                                    value={dateProgrammation}
                                                                    onChange={(e) => setDateProgrammation(e.target.value)}
                                                                    min={new Date().toISOString().slice(0, 16)}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Boutons en bas à droite */}
                                                <div className="d-flex justify-content-end gap-2 pt-3 border-top">
                                                    <button
                                                        className="btn btn-success d-flex align-items-center mr-2"
                                                        onClick={handleSauvegarder}
                                                        disabled={isLoading}
                                                    >
                                                        {isLoading ? (
                                                            <FaSpinner className="mr-1 fa-spin" />
                                                        ) : (
                                                            <FaEdit className="mr-1" />
                                                        )}
                                                        {isLoading ? 'Sauvegarde...' : estProgrammee ? 'Programmer' : 'Sauvegarder'}
                                                    </button>


                                                    {/* Afficher le bouton Envoyer seulement si NON programmé */}
                                                    {!estProgrammee && (
                                                        <button
                                                            className="btn btn-success d-flex align-items-center"
                                                            onClick={handleEnvoyer}
                                                            disabled={isLoading}
                                                        >
                                                            {isLoading ? (
                                                                <FaSpinner className="mr-1 fa-spin" />
                                                            ) : (
                                                                <FaEnvelope className="mr-1" />
                                                            )}
                                                            {isLoading ? 'Envoi...' : "Envoyer"}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {activeMenu === 'courriels' && (
                                            <div className="d-flex gap-3 h-100" style={{ minHeight: '500px' }}>
                                                {/* Sous-partie gauche - Liste des newsletters (35%) */}
                                                <div className="flex-grow-0 flex-shrink-0 border rounded" style={{ width: '35%' }}>
                                                    <div className="d-flex flex-column h-100">
                                                        <div className="p-3 border-bottom bg-light rounded-top">
                                                            <h5 className="mb-0 text-dark">Newsletters</h5>
                                                        </div>
                                                        <div
                                                            className="flex-grow-1 overflow-auto"
                                                            style={{ maxHeight: '600px' }}
                                                        >
                                                            {newslettersLoading ? (
                                                                // Loader pendant le chargement
                                                                <div className="d-flex justify-content-center align-items-center p-5">
                                                                    <div className="text-center">
                                                                        <FaSpinner className="fa-spin text-success mb-2" size={30} />
                                                                        <p className="text-muted mb-0">Chargement des newsletters...</p>
                                                                    </div>
                                                                </div>
                                                            ) : newsletters.length === 0 ? (
                                                                // Message quand il n'y a pas de newsletters
                                                                <div className="d-flex flex-column align-items-center justify-content-center p-5 text-center">
                                                                    <FaEnvelopeOpen size={40} className="text-muted mb-3" />
                                                                    <h6 className="text-muted mb-2">Aucune newsletter</h6>
                                                                    <p className="text-muted small">
                                                                        Aucune newsletter n'a été créée pour le moment.
                                                                    </p>
                                                                </div>
                                                            ) : (
                                                                // Liste des newsletters
                                                                newsletters.map(newsletter => (
                                                                    <div
                                                                        key={newsletter.id}
                                                                        className={`p-3 border-bottom cursor-pointer ${selectedNewsletter?.id === newsletter.id
                                                                            ? 'bg-success text-white'
                                                                            : 'bg-white'
                                                                            }`}
                                                                        onClick={() => setSelectedNewsletter(newsletter)}
                                                                        style={{
                                                                            transition: 'background-color 0.3s ease',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                    >
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div className="fw-semibold mb-1" style={{ fontSize: '14px' }}>
                                                                                {newsletter.objet}
                                                                            </div>
                                                                            <span className={`badge ${newsletter.statut === 'envoyee'
                                                                                ? 'badge-success'
                                                                                : newsletter.statut === 'programmee'
                                                                                    ? 'badge-warning'
                                                                                    : 'badge-secondary'
                                                                                }`}>
                                                                                {newsletter.statut}
                                                                            </span>
                                                                        </div>

                                                                        <small className={selectedNewsletter?.id === newsletter.id ? 'text-light' : 'text-muted'}>
                                                                            {new Date(newsletter.date_creation).toLocaleDateString('fr-FR')}
                                                                        </small>
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div className={selectedNewsletter?.id === newsletter.id ? 'text-light' : 'text-muted'}>
                                                                                {newsletter?.nombre_destinataires || 0} destinataire(s)
                                                                            </div>
                                                                            <div className="d-flex gap-1">
                                                                                {(newsletter.statut !== 'envoyee' && newsletter.type_newsletter !== 'SMS') && (
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-success mr-2"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            handleShowSendModal(newsletter);
                                                                                        }}
                                                                                        disabled={isLoading}
                                                                                    >
                                                                                        <FaTelegramPlane size={12} />
                                                                                    </button>
                                                                                )}
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-danger"
                                                                                    onClick={handleShowDeleteModal}
                                                                                    disabled={isLoading}
                                                                                >
                                                                                    <FaTrashAlt size={12} />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Sous-partie droite - Contenu de la newsletter (65%) */}
                                                <div className="flex-grow-1 flex-shrink-0 border rounded" style={{ width: '65%' }}>
                                                    <div className="d-flex flex-column h-100 p-3">
                                                        {selectedNewsletter ? (
                                                            <>
                                                                <div className="mb-3 pb-2 border-bottom">
                                                                    <h4 className="text-dark mb-2">{selectedNewsletter.objet}</h4>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <span className="text-muted">
                                                                            Créée le: {new Date(selectedNewsletter.date_creation).toLocaleDateString('fr-FR', {
                                                                                year: 'numeric',
                                                                                month: 'long',
                                                                                day: 'numeric',
                                                                                hour: '2-digit',
                                                                                minute: '2-digit'
                                                                            })}
                                                                        </span>
                                                                        <span className={`badge ${selectedNewsletter.statut === 'envoyee'
                                                                            ? 'badge-success'
                                                                            : selectedNewsletter.statut === 'programmee'
                                                                                ? 'badge-warning'
                                                                                : 'badge-secondary'
                                                                            }`}>
                                                                            {selectedNewsletter.statut}
                                                                        </span>
                                                                    </div>
                                                                    {selectedNewsletter.date_envoi && (
                                                                        <div className="text-muted small mt-1">
                                                                            Envoyée le: {new Date(selectedNewsletter.date_envoi).toLocaleDateString('fr-FR', {
                                                                                year: 'numeric',
                                                                                month: 'long',
                                                                                day: 'numeric',
                                                                                hour: '2-digit',
                                                                                minute: '2-digit'
                                                                            })}
                                                                        </div>
                                                                    )}
                                                                    {selectedNewsletter?.frequence && (
                                                                        <div className="text-muted small mt-1">
                                                                            Programmation: {selectedNewsletter.frequence} -
                                                                            {selectedNewsletter.date_programmation &&
                                                                                new Date(selectedNewsletter.date_programmation).toLocaleDateString('fr-FR', {
                                                                                    year: 'numeric',
                                                                                    month: 'long',
                                                                                    day: 'numeric',
                                                                                    hour: '2-digit',
                                                                                    minute: '2-digit'
                                                                                })
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div
                                                                    className="flex-grow-1 overflow-auto"
                                                                    style={{ lineHeight: '1.6' }}
                                                                >
                                                                    <div
                                                                        dangerouslySetInnerHTML={{ __html: selectedNewsletter.contenu }}
                                                                        className="newsletter-content"
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center">
                                                                <FaEnvelope size={50} className="text-muted mb-3" />
                                                                <h5 className="text-muted mb-2">Sélectionnez une newsletter</h5>
                                                                <p className="text-muted">
                                                                    Cliquez sur une newsletter dans la liste pour en afficher le contenu.
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                    <Modal.Header>
                        <Modal.Title>Confirmer la suppression</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Êtes-vous sûr de vouloir supprimer la newsletter : {selectedNewsletter && selectedNewsletter.titre} ?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>
                            Annuler
                        </Button>
                        <Button variant="success" onClick={handleSupprimerNewsLetter}>
                            Supprimer
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showSendModal} onHide={handleCloseSendModal}>
                    <Modal.Header>
                        <Modal.Title>Confirmer l'envoi</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Êtes-vous sûr de vouloir envoyer la newsletter : <strong>{newsletterToSend?.objet}</strong> ?
                        <br />
                        <small className="text-muted">
                            Cette action enverra l'email à tous les destinataires configurés.
                        </small>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseSendModal}>
                            Annuler
                        </Button>
                        <Button
                            variant="success"
                            onClick={handleEnvoyerNewsletterExistante}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <FaSpinner className="mr-1 fa-spin" />
                                    Envoi en cours...
                                </>
                            ) : (
                                <>
                                    <FaEnvelope className="mr-1" />
                                    Confirmer l'envoi
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showImportModal} onHide={() => setShowImportModal(false)}>
                    <Modal.Header>
                        <Modal.Title>Importer des numéros</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group>
                                <Form.Label>Télécharger un fichier Excel</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".xlsx,.xls"
                                    onChange={(e) => setImportFile(e.target.files[0])}
                                />
                                {/* <Form.Text className="text-muted">
                                    Format attendu : Colonne avec les numéros de téléphone
                                </Form.Text> */}
                            </Form.Group>

                            {/* AJOUTER CETTE SECTION POUR LE CHOIX DU PAYS */}
                            <Form.Group className="mt-3">
                                <Form.Group className="mt-3">
                                    <Form.Label>Pays</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={paysImport}
                                        onChange={(e) => setPaysImport(e.target.value)}
                                        className="form-select"
                                    >
                                        <option value="Bénin">Bénin</option>
                                        <option value="Autre">Autre</option>
                                        <option value="Tous">Tous les numéros</option>
                                    </Form.Control>
                                </Form.Group>
                            </Form.Group>
                        </Form>

                        <div className="mt-3">
                            <h6>Instructions :</h6>
                            <ul className="small">
                                <li>Le fichier doit être au format Excel (.xlsx ou .xls)</li>
                                <li>La première colonne doit contenir les numéros de téléphone</li>
                                <li>La première ligne (en-tête) sera ignorée</li>
                                <li>Seuls les numéros valides seront importés</li>
                            </ul>
                            <div className="alert alert-info p-2 small">
                                <strong>Note importante :</strong> Si vous sélectionnez "Bénin", seuls les numéros béninois seront importés.
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowImportModal(false)}>
                            Annuler
                        </Button>
                        <Button
                            variant="success"
                            onClick={handleImportExcel}
                            disabled={!importFile || importLoading || !paysImport}
                        >
                            {importLoading ? (
                                <>
                                    <FaSpinner className="fa-spin mr-1" />
                                    Importation...
                                </>
                            ) : 'Importer'}
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showImportEmailModal} onHide={() => setShowImportEmailModal(false)}>
                    <Modal.Header>
                        <Modal.Title>Importer des emails depuis Excel</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group>
                                <Form.Label>Télécharger un fichier Excel</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".xlsx,.xls,.csv"
                                    onChange={(e) => setImportEmailFile(e.target.files[0])}
                                />
                                <Form.Text className="text-muted">
                                    Format attendu : Une colonne avec les adresses email
                                </Form.Text>
                            </Form.Group>
                        </Form>

                        <div className="mt-3">
                            <h6>Instructions :</h6>
                            <ul className="small">
                                <li>Le fichier doit être au format Excel (.xlsx, .xls) ou CSV</li>
                                <li>La première colonne doit contenir les adresses email</li>
                                <li>La première ligne (en-tête) sera ignorée</li>
                                <li>Seules les adresses email valides seront importées</li>
                            </ul>
                            <div className="alert alert-info p-2 small">
                                <strong>Note :</strong> Les doublons seront automatiquement éliminés.
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowImportEmailModal(false)}>
                            Annuler
                        </Button>
                        <Button
                            variant="success"
                            onClick={handleImportExcelEmail}
                            disabled={!importEmailFile || importEmailLoading}
                        >
                            {importEmailLoading ? (
                                <>
                                    <FaSpinner className="fa-spin mr-1" />
                                    Importation...
                                </>
                            ) : 'Importer les emails'}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default NewsLetters;